import { createSelector } from "@reduxjs/toolkit";
import { selectVisibleFacets } from "./select-visible-facets";

export const selectVisibleTextFacetValue = (facetFieldName: string) =>
	createSelector([selectVisibleFacets], (visibleFacets) => {
		let values = visibleFacets[facetFieldName] as string[];

		if (values === undefined) {
			return null;
		}

		return values;
	});
